// not in use
import { useQuery, useQueryClient } from '@tanstack/react-query';

import { useRestaurantsService } from '@restworld/data-services';
import { PlacesInfoResponseType } from '@restworld/utility-types';

import { useEmployerRestaurantDetails } from './use-employer-restuarant-details';

export const useRestaurantPlacesInfoQuery = () => {
  const employerService = useRestaurantsService();

  const queryKey = useQueryKey();
  useQuery({
    queryKey,
    queryFn: async () => (await employerService.restaurantPlacesInfo(queryKey[1])).data,
    enabled: !!queryKey[1],
  });
};
const useQueryKey = () => {
  const restaurantDetails = useEmployerRestaurantDetails();
  return ['restaurant-places-info', restaurantDetails?.id];
};
export const useRestaurantPlacesInfo = () => {
  const queryKey = useQueryKey();

  const queryClient = useQueryClient();
  return queryClient.getQueryData(queryKey) as PlacesInfoResponseType;
};
